'use client';
const MANIFEST_STYLES = {
    utility: {
        hashed: 'utility.fd426993c54cb69b6d6d0dfaae7b67fa.min.css',
        versioned: 'utility.min.css'
    },
    core: {
        hashed: 'core.d869eb4d4b4773697ecefd3697498684.min.css',
        versioned: 'core.min.css'
    },
    zoomControls: {
        hashed: 'zoom-controls.a212b3b259dc4616643396d0bfb17a38.min.css',
        versioned: 'zoom-controls.min.css'
    },
    visible: {
        hashed: 'visible.388bb400607befa65ff09c5a81d28b7f.min.css',
        versioned: 'visible.min.css'
    },
    toggleSwitch: {
        hashed: 'toggle-switch.2f048ec712a8b239283fe71eaeff6e0a.min.css',
        versioned: 'toggle-switch.min.css'
    },
    thumbnailsHero: {
        hashed: 'thumbnails-hero.5e21641a60eb1fb0786e24d14fe7ea22.min.css',
        versioned: 'thumbnails-hero.min.css'
    },
    tabs: {
        hashed: 'tabs.9429d71c7cb8cbe60838edca72475d8f.min.css',
        versioned: 'tabs.min.css'
    },
    table: {
        hashed: 'table.4e52d9069a843e8ca01301fc7f341565.min.css',
        versioned: 'table.min.css'
    },
    stepIndicator: {
        hashed: 'step-indicator.7475c81fefa8ce680a43d4fad6c5cb22.min.css',
        versioned: 'step-indicator.min.css'
    },
    standardTile: {
        hashed: 'standard-tile.fe2340e172b404d510285d511a080903.min.css',
        versioned: 'standard-tile.min.css'
    },
    spinner: {
        hashed: 'spinner.e28c0ae32bd5b461b339d7683cf90c86.min.css',
        versioned: 'spinner.min.css'
    },
    selectionSet: {
        hashed: 'selection-set.82318e4f29a1d1346c840e5a462a382d.min.css',
        versioned: 'selection-set.min.css'
    },
    ratingsStars: {
        hashed: 'ratings-stars.12638464b8b6dc6fe50e19fb1a8acf1d.min.css',
        versioned: 'ratings-stars.min.css'
    },
    progressiveImage: {
        hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
        versioned: 'progressive-image.min.css'
    },
    progressBar: {
        hashed: 'progress-bar.eb0d081bb31e4ea4ed2c329001dde212.min.css',
        versioned: 'progress-bar.min.css'
    },
    pricing: {
        hashed: 'pricing.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'pricing.min.css'
    },
    priceBar: {
        hashed: 'price-bar.94823f3bcdaf4c639e1bc735cd9b349d.min.css',
        versioned: 'price-bar.min.css'
    },
    popover: {
        hashed: 'popover.f8a6655877534424542efbe757aff0bd.min.css',
        versioned: 'popover.min.css'
    },
    pagination: {
        hashed: 'pagination.d49a475685366ed500c595500e187b8f.min.css',
        versioned: 'pagination.min.css'
    },
    modalDialog: {
        hashed: 'modal-dialog.eb0281f13b225af61b6000b3364af7c7.min.css',
        versioned: 'modal-dialog.min.css'
    },
    listbox: {
        hashed: 'listbox.8fa991a1ed8bc0e4674056e0c8531353.min.css',
        versioned: 'listbox.min.css'
    },
    icon: {
        hashed: 'icon.5238539543e3e64f95f577ee1607b606.min.css',
        versioned: 'icon.min.css'
    },
    hidden: {
        hashed: 'hidden.90549d732670d4ba02fac0dc001a0bb8.min.css',
        versioned: 'hidden.min.css'
    },
    grid: {
        hashed: 'grid.393ab9dc32ba1b6be15bf4d30fc3c6d6.min.css',
        versioned: 'grid.min.css'
    },
    fieldSet: {
        hashed: 'field-set.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'field-set.min.css'
    },
    carousel: {
        hashed: 'carousel.208ea22bba3d8f04606c38b10c7012c0.min.css',
        versioned: 'carousel.min.css'
    },
    button: {
        hashed: 'button.4609c00f349bddcc0b2006a626f8feed.min.css',
        versioned: 'button.min.css'
    },
    banner: {
        hashed: 'banner.5d35a1074dac6ff09007e2f9bee8a8b4.min.css',
        versioned: 'banner.min.css'
    },
    avatar: {
        hashed: 'avatar.1f9246f389d891f03fe55ac84d65854a.min.css',
        versioned: 'avatar.min.css'
    },
    anchorBar: {
        hashed: 'anchor-bar.00a3273f7217a62d93a34326a46dbb05.min.css',
        versioned: 'anchor-bar.min.css'
    },
    alertBox: {
        hashed: 'alert-box.75b11b807a85b44a620fd47e0c3b9584.min.css',
        versioned: 'alert-box.min.css'
    },
    accordion: {
        hashed: 'accordion.6027ffefd2c658aece251147df75b7a4.min.css',
        versioned: 'accordion.min.css'
    }
};

export { MANIFEST_STYLES };
